module.exports = __webpack_public_path__ + "static/img/a101.4bae89d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a101.jpg
// module id = WT6a
// module chunks = 0